import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// eslint-disable-next-line
import style from "./components/style.css";

import { Route, BrowserRouter, Routes } from "react-router-dom";

import {
  Login,
  Cadastro,
  Redefinir,
  Home,
  Form1,
  Form2,
  Form3,
  Form4,
  Contato,
} from "./pages";

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/redefinir" element={<Redefinir />} />
        <Route path="/home" element={<Home />} />
        <Route path="/form1" element={<Form1 />} />
        <Route path="/form2" element={<Form2 />} />
        <Route path="/form3" element={<Form3 />} />
        <Route path="/form4" element={<Form4 />} />
        <Route path="/contato" element={<Contato />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
